import React from 'react';

// Comps
import AccountLoginForm from '@project-stories/ecommerce/Account/AccountLoginForm/AccountLoginForm';
import AccountRegisterForm from '@project-stories/ecommerce/Account/AccountRegisterForm/AccountRegisterForm';

type Props = {
    section: any;
    isRegister: boolean;
    showCustomFields?: boolean;
    signUpFields?: any;
    blockSettings?: any;
};

const AccountForm = ({ section, isRegister, showCustomFields, signUpFields, blockSettings }: Props) => {
    return (
        <div className='rounded-md md:min-w-[390px]'>
            {isRegister ? (
                <AccountRegisterForm
                    section={section}
                    showCustomFields={showCustomFields}
                    signUpFields={signUpFields}
                />
            ) : (
                <AccountLoginForm
                    section={section}
                    blockSettings={blockSettings}
                />
            )}
        </div>
    );
};

export default AccountForm;